/**
 * A trail's length as a visitor reads it: "4.2 mi", or, for a trail
 * under a twentieth of a mile (or km), "180 ft" — because "0.0 mi" says
 * nothing. The server sends the value to three places so a short trail
 * still has something to convert. TrailDetail.vue applies the same
 * threshold to the trail page's own stat, axis and readouts.
 */
export const SHORT_BELOW = 0.05;
const FT_PER_MI = 5280;

export function lengthText(value, unit) {
    const v = Number(value);
    if (!(v > 0)) return '';
    const km = unit === 'km';
    if (v < SHORT_BELOW) {
        const small = Math.round(km ? v * 1000 : v * FT_PER_MI);
        return `${small.toLocaleString('en-US')} ${km ? 'm' : 'ft'}`;
    }
    return `${v.toFixed(1)} ${km ? 'km' : 'mi'}`;
}
